import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Typography } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { MODAL_KEY } from 'modules/auth/core/modal-key';
import Stepper from 'modules/classes/components/Steper';
import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';
import type { Courses } from 'modules/dashboard/core/type';

import withRole from 'hooks/withRole';

import { ClassesAddComp } from '../components/ClassesAddComp';
import { ClassesCreateComp } from '../components/ClassesCreateComp';
import { getTrainersColumn, getTrainersInClasses } from '../core/columns';
import { useClassAddControler } from '../core/controller/classes-add';

const ClassesAddPage = () => {
  const {
    goBackToCreatePage,
    selectedTrainers,
    onChangeSelectedTrainers,
    trainersData,
    searchTrainerValue,
    onChangeSearchTrainerValue,
    selectedData,
    handleAddTrainersToClass,
    handleDeleteTrainerInClass,
    activePage,
    searchCourseValue,
    onChangeSearchCourseValue,
    coursesData,
    goToAddPage,
    handleSelectedCourse,
    courseSelected,
    onDeleteSelectedCourse,
    disabledNextButton,
    name,
    description,
    handleChange,
    disabledButton,
    handleSubmit,
    thumbnailUrl,
    onChangeThumbnail,
    onDeleteThumbnail,
    goBack,
    roleKey,
    institutions,
    institutionId,
    onChangeInstitution,
    handleGetWidthAndHeightThumbnail,
    onChangeSearchInstitution,
    searchSelect,
    hasMoreTrainer,
    handleLoadMoreTrainer,
    stations,
    onChangeStation,
    selectedStation,
  } = useClassAddControler();

  const columns = getTrainersInClasses(selectedTrainers, onChangeSelectedTrainers);

  const trainerColumns = getTrainersColumn(handleDeleteTrainerInClass);

  const isBiologicAdmin = roleKey === RoleKey.BIOLOGIC_ADMIN;

  const steps = [{ title: 'Class details' }, { title: 'Add trainers' }];

  const currentStep = activePage.isCreate ? 0 : activePage.isAdd ? 1 : 0;

  return (
    <>
      {activePage.isCreate ? (
        <HeaderDetailPage title="Add class" goBack={goBack} style={{ marginBottom: 0 }} />
      ) : (
        <Typography variant="h3" weight={700}>
          Add class
        </Typography>
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '40px 0 24px',
        }}
      >
        <Stepper currentStep={currentStep} steps={steps} />
      </div>

      {activePage.isCreate ? (
        <ClassesCreateComp
          searchValue={searchCourseValue.value}
          onChangeSearchValue={onChangeSearchCourseValue}
          coursesData={coursesData}
          goToAddPage={goToAddPage}
          handleSelectedCourse={handleSelectedCourse}
          selectedCourse={courseSelected as Courses}
          onDeleteSelectedCourse={onDeleteSelectedCourse}
          disabledNextButton={disabledNextButton}
          name={name}
          description={description}
          handleChange={handleChange}
          file={thumbnailUrl.value}
          onChangeFiles={onChangeThumbnail}
          onDeleteThumbnail={onDeleteThumbnail}
          isBiologicAdmin={isBiologicAdmin}
          institutions={institutions}
          institutionId={institutionId}
          onChangeInstitution={onChangeInstitution}
          handleGetWidthAndHeightThumbnail={handleGetWidthAndHeightThumbnail}
          onChangeSearchInstitution={onChangeSearchInstitution}
          searchSelect={searchSelect.value}
          stations={stations}
          onChangeStation={onChangeStation}
          selectedStation={selectedStation}
        />
      ) : (
        <ClassesAddComp
          trainersData={trainersData}
          handleAddTrainersToClass={handleAddTrainersToClass}
          searchValue={searchTrainerValue.value}
          onChangeSearchValue={onChangeSearchTrainerValue}
          columns={columns}
          trainerColumns={trainerColumns}
          selectedData={selectedData}
          goBackToCreatePage={goBackToCreatePage}
          disabledButton={disabledButton}
          handleSubmit={handleSubmit}
          hasMoreTrainer={hasMoreTrainer.value}
          handleLoadMoreTrainer={handleLoadMoreTrainer}
        />
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.CREATE_CLASS}
        content={'To create a class, at least one Admin Trainer is required.'}
        header={'Warning'}
        onCancel={() => {}}
        onSubmit={() => {}}
        submitButton={{ hide: true }}
        cancelButton={{ hide: true }}
      />
    </>
  );
};

export default withRole([RoleKey.INSTITUTION_ADMIN, RoleKey.BIOLOGIC_ADMIN])(ClassesAddPage);
